// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-datetime {
  padding: 0;
}

#chips-container {
  --padding-start: 16px;
}
#chips-container ion-label {
  margin: 0;
}
#chips-container ion-label div {
  margin-bottom: 24px;
}
#chips-container ion-label ion-chip {
  border-radius: 20px;
  height: 33px;
}
#chips-container ion-label ion-chip ion-avatar {
  border: 0;
  padding: 0;
  width: 24px;
  height: 24px;
}
#chips-container ion-label ion-chip ion-avatar div {
  font-size: 12px;
}

.ion-margin {
  margin: 24px;
}

.custom-title {
  color: var(--ion-color-light) !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/events-core/lib/components/event-create-modal/event-create.modal.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;;AAEA;EACE,qBAAA;AACF;AACE;EACE,SAAA;AACJ;AACI;EACE,mBAAA;AACN;AAEI;EACE,mBAAA;EACA,YAAA;AAAN;AACM;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AACR;AAAQ;EACE,eAAA;AAEV;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,wCAAA;AAFF","sourcesContent":["ion-datetime {\n  padding: 0;\n}\n\n#chips-container {\n  --padding-start: 16px;\n\n  ion-label {\n    margin: 0;\n\n    div {\n      margin-bottom: 24px;\n    }\n\n    ion-chip {\n      border-radius: 20px;\n      height: 33px;\n      ion-avatar {\n        border: 0;\n        padding: 0;\n        width: 24px;\n        height: 24px;\n        div {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n}\n\n.ion-margin{\n  margin: 24px;\n}\n\n.custom-title{\n  color: var(--ion-color-light) !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
